import React, { useEffect, useState } from 'react'
import OtherDataForm from '../components/forms/OtherDataForm'
import { useClaimant } from '../context/col'

import {
  CaseReportParamsType,
  CaseReportRespType,
  OtherDataType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import { putCaseReport } from '../services/case-report/put'

export type OtherDataPageProps = {
  transitions: OtherDataPageTransitions
}

export type OtherDataPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const OtherDataPage = (props: OtherDataPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, handlePageDataChanged] = useState<boolean>(true)

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [dispatch, ifEqual])
  const { fetch: fetchData, pending: loading } = useGetData({})

  React.useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Funkce 'handleOtherDataPageSubmitted' je volana z komponenty OtherDataForm
  // a prijma naporizovana data ve strukture datoveho modelu COL: OtherDataType
  const handleOtherDataPageSubmitted = (otherDataParams: OtherDataType) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state
    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      other: otherDataParams,
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    a zmenime 'stranku'
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 5 },
    })

    // 4. data posilame na server funkcí, která odesílá data na server a obsluhuje (loading+error)
    //    A) nejdrive to napiseme v teto komponente -- do funkce
    //    B) POZDEJI -- V JINEM KROKU -- pak zrefaktorujeme do jednotneho hook (jako useGetData)
    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  // 4. Funkce OtherDataPage.doPutCaseReport prijma parametry:
  //    - caseReportId
  //    - caseReportParams
  //    A ty odesila pomoci services/case-report/putCaseReport.
  //    Funkce doPutCaseReport ovlada prechodem na dalsi stranku a zobrazuje chybovy stav
  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      // USPESNY PUT DAT CaseReport
      // 1. VYNULOVAT PRIPADNE ERRORY ve state
      // TODO 2022/01/24
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      // 2. PRECHOD
      //history.push(pathToOverview)
      props.transitions.goToNextPage()
    },
    onError: (error) => {
      // 1. dispatch ('error')
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const handleOtherDataPageBack = () => {
    props.transitions.goBack()
    /*
    const treatmentTypes = state.loadedCaseReportResp?.caseME?.treatmentTypes
    if (state.caseType === 'ME' && !!treatmentTypes?.length) {
      changeTreatmentExpensesType(
        treatmentTypes[treatmentTypes?.length - 1] ?? ''
      )
      history.push(pathToTreatmentExpenses)
    }
    if (state.caseType === 'CA') {
      history.push(pathToCancellationExpenses)
    }
    if (state.caseType === 'PL') {
      history.push(pathToLiability)
    }
    if (state.caseType === 'BA') {
      history.push(pathToBaggage)
    }
    if (state.caseType === 'PA') {
      history.push(pathToPersonalAccident)
    }
    if (state.caseType === 'TI') {
      history.push(pathToTicket)
    }
    */
  }
  const currentOtherData: OtherDataType | null =
    state.loadedCaseReportResp?.other ?? null

  return (
    <OtherDataForm
      otherData={currentOtherData}
      onPageContinue={handleOtherDataPageSubmitted}
      onPageBack={handleOtherDataPageBack}
      errorMessage={state.error}
      isContinueInProgress={pending}
      isDataLoading={loading}
      setIfEqual={handlePageDataChanged}
      caseType={state.caseType}
    />
  )
}

export default OtherDataPage
